import React from 'react';

import { Assets } from '@assets';
import { Button } from '@elements/button';
import { Text } from '@elements/text';
import { useEmailQuote } from '@hooks';
import { i18n } from '@i18n';

export const EmailQuoteHeader: React.FC = () => {
  const { closeEmailQuoteModal } = useEmailQuote();

  return (
    <div className="overflow-hidden relative">
      <img
        src={Assets.EmailQuoteHeaderMobile}
        className="object-cover w-full md:hidden rounded-t-2xl"
      />
      <img
        src={Assets.EmailQuoteHeaderDesktop}
        className="object-cover w-full hidden md:block rounded-t-xl"
      />
      <div className="absolute top-0 right-0 pt-4 pr-4">
        <Button size="sm" icon="close" variant="primary" onClick={closeEmailQuoteModal} />
      </div>
      <Text
        variant="h4-24/sb"
        className="text-mono-100 absolute whitespace-pre-line w-full px-4 bottom-4 inset-x-0 sm:px-6 md:px-10">
        {i18n.t('emailQuote.header')}
      </Text>
    </div>
  );
};
